<script>
    import {Listeners} from "../../../constants/listeners";
    import Checkbox from "primevue/checkbox";

    export default {
        props: {
            model: Object,
        },
        data() {
            return {
                open: false
            }
        },
        computed: {
            isFolder(){
                return this.model.inner &&
                    this.model.inner.length
            }
        },
        methods: {
            toggle() {
                if (this.isFolder) {
                    this.open = !this.open
                }
            },
            close(){
                if (this.isFolder) {
                    this.open = false
                }
            },
            checked() {
                this.model.isChecked = !this.model.isChecked;

                this.model.touched = this.model.isChecked;

                recChecked(this.model);
                if(this.model.inner && this.model.inner.length && this.model.isChecked){
                    this.open = true;
                }
                function recChecked(model){
                    if(model.inner && model.inner.length){

                        model.inner.forEach(el => {

                            el.isChecked = model.isChecked;

                            recChecked(el);
                        });

                    }
                }

            }
        },
        mounted() {
            if(this.model.touched && this.isFolder){
                this.open = true;
            }
            this.$emitter.on(Listeners.REGION_HIDE_ITEM, this.close);
        },
        components: {
            Checkbox,
        }
    }
</script>
<template>
    <li>
        <div class="field-checkbox">
            <Checkbox @click="checked" :model-value="model.isChecked" binary />
            <label :class="{toggle: isFolder}" @click="toggle">{{model.name}}</label>
            <span v-if="isFolder" class="toggle ml-1" @click="toggle">[{{open ? '-' : '+'}}]</span>
        </div>
        <ul v-show="open" v-if="isFolder">
            <region-items
                class="tree-item"
                v-for="model in model.inner"
                :key="model.id"
                :model="model">
            </region-items>
        </ul>
    </li>
</template>

<style scoped>
    .toggle{
        cursor: pointer;
    }
</style>
